import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useProgress } from '@/contexts/ProgressProvider';

const AuthScreen = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuth0();
  const { setProgress } = useProgress();

  useEffect(() => {
    // console.log('AuthScreen', isLoading);
    async function signIn() {
      // console.log('AuthScreen signIn', user, isAuthenticated);
      if (isAuthenticated) {
        navigate('/assets/list');
      }
    }
    signIn();
  }, [user]);

  useEffect(() => {
    setProgress(isLoading ? -1 : 100);
  }, [isLoading]);

  return <div />;
};

export default AuthScreen;
